import { useCallback } from 'react';

import type { FamilyEvent } from '@/features/guardian/family-events';
import { useGuardianStackNavigation, useScaling } from '@/hooks';

type UseOpenEventDetailOptions = {
  /** Kids tablet uses this to open the animated third column. */
  onInlineOpen?: (event: FamilyEvent) => void;
};

/** Routes every Event Detail entry point through one responsive decision. */
export function useOpenEventDetail(options: UseOpenEventDetailOptions = {}) {
  const { onInlineOpen } = options;
  const { isTablet } = useScaling();
  const navigation = useGuardianStackNavigation();

  return useCallback(
    (event: FamilyEvent) => {
      if (isTablet && onInlineOpen) {
        onInlineOpen(event);
        return;
      }

      if (isTablet) {
        navigation.navigate('GuardianDashboard', {
          screen: 'Kids',
          params: { eventId: event.id },
        });
        return;
      }

      navigation.navigate('GuardianEventDetail', {
        eventId: event.id,
        playerId: event.playerId,
      });
    },
    [isTablet, navigation, onInlineOpen],
  );
}
